<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <b-row style="max-width: 100%" class="padding-ten-tb">
      <b-col xs="12" sm="12" md="12" lg="4">
        <h5 class="color-gray">{{ title }}</h5>
      </b-col>
    </b-row>

    <slot />
  </div>
</template>

<script>
export default {
  name: "LiquidacionReportesPageLayout",

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
